const toCamelCase = str => {
    const camelCased = str.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase()
    })
    return camelCased
}

const objectIsEmpty = obj => {
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false
    }
    return true
}

const splitDateTimeString = dtt => {
    if (!dtt) return { date: '', time: '' }
    dtt = dtt.split(' ')
    let date = dtt[0]
    let time = dtt[1].split('.')
    time = time[0]
    return { date, time }
}

const padStartInteger = (int, length, str = '0') =>
    ('' + int).padStart(length, str)

const dateToYYYYMMDD = date =>
    `${date.getFullYear()}-${padStartInteger(
        date.getMonth() + 1,
        2,
        0
    )}-${padStartInteger(date.getDate(), 2, 0)}`

const dateToHHmmSS = date =>
    `${padStartInteger(date.getHours(), 2, 0)}:${padStartInteger(
        date.getMinutes(),
        2,
        0
    )}:${padStartInteger(date.getSeconds(), 2, 0)}`

const dateToYYYYMMDDHHmmSS = date =>
    dateToYYYYMMDD(date) + ' ' + dateToHHmmSS(date)

export {
    toCamelCase,
    objectIsEmpty,
    splitDateTimeString,
    padStartInteger,
    dateToYYYYMMDD,
    dateToHHmmSS,
    dateToYYYYMMDDHHmmSS,
}
